// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"14c57462","977":"88494538"}[chunkId] + ".chunk.js";
};